import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import { connect } from 'react-redux';
import {
  updateSignupGenerator,
  clearUpdateSignupGeneratorStatus,
} from 'redux/signup-generator/actions';

import onClickOutside from 'react-onclickoutside';

import validate from './validate';

export const defaultFieldValues = {
  button_text: i18n.t("Click to Subscribe"),
  success_text: i18n.t("Thanks for Subscribing!"),
  tc_url: 'https://url',
  tc_url_text: i18n.t("View Terms & Сonditions"),
};

const fieldDecorator = (WrappedComponent) => {

  const ENTER_KEY = 13;

  class EmailSignupFieldDecorator extends Component {
    static propsTypes = {
      noClickOutside: PropTypes.bool,
      value: PropTypes.string,
      name: PropTypes.string,
      required: PropTypes.bool,
      updateSignupGeneratorSuccess: PropTypes.object,
      updateSignupGeneratorError: PropTypes.object,
      updateSignupGenerator: PropTypes.func,
      clearUpdateSignupGeneratorStatus: PropTypes.func,
    };
    static defaultProps = {
      noClickOutside: false,
      value: null,
      name: null,
      required: false,
      updateSignupGeneratorSuccess: null,
      updateSignupGeneratorError: null,
      updateSignupGenerator: null,
      clearUpdateSignupGeneratorStatus: null,
    };

    state = {
      initialValue: '',
      currentValue: '',
      invalid: null,
      successUpdatedField: {},
    };

    componentDidMount() {
      document.addEventListener('keyup', this.onEnterClick);
      if (this.props.value) {
        this.setState({
          initialValue: this.props.value,
          currentValue: this.props.value,
        });
      }
      this.executeValidation();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value && !this.props.noClickOutside) {
        this.setState({ currentValue: this.props.value });
      }
      if (prevProps.value !== this.props.value && this.props.noClickOutside) { // handle dropdown submit
        this.setState({ currentValue: this.props.value }, this.changeInputValue);
      }
    }

    componentWillUnmount() {
      document.removeEventListener('keyup', this.onEnterClick);
      this.props.clearUpdateSignupGeneratorStatus();
    }

    executeValidation = () => {
      this.setState({
        invalid: validate(
          this.props.name,
          this.props.value,
          this.props.required,
        ),
      });
    };

    handleValidationChoices = () => {
      let error = null;
      if (this.state.invalid) {
        error = { text: Object.keys(this.state.invalid).map(i => this.state.invalid[i]) };
      } else if (this.props.updateSignupGeneratorError && this.props.updateSignupGeneratorError[this.props.name]) {
        error = { text: this.props.updateSignupGeneratorError[this.props.name] }
      }
      return error;
    }

    onEnterClick = (event) => {
      if (event.keyCode === ENTER_KEY) {
        this.executeValidation();
        this.changeInputValue();
      }
    };

    handleClickOutside = () => {
      this.executeValidation();
      this.changeInputValue();
    };

    changeInputValue = () => {
      if (!this.state.invalid && this.state.currentValue !== this.state.initialValue) {
        this.setState({ initialValue: this.state.currentValue }, this.updateValues(this.state.currentValue));
      }
    };

    updateValues = (value) => {
      const form = new FormData();
      form.append(`${this.props.name}`, `${value}`);
      this.setState({ successUpdatedField: { name: this.props.name, success: true } }, this.resetField);
      this.props.updateSignupGenerator(this.props.me.signup_generator, form);
    };

    resetField = () => {
      setTimeout(() => { this.setState({ successUpdatedField: {} }) }, 500)
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          error={this.handleValidationChoices()}
          successUpdatedField={this.state.successUpdatedField}
        />
      );
    }
  }

  const mapStateToProps = state => (
    {
      me: state.usersReducer.me,
      updateSignupGeneratorSuccess: state.emailSignupGenerator.updateSignupGeneratorSuccess,
      updateSignupGeneratorError: state.emailSignupGenerator.updateSignupGeneratorError,
    }
  );

  return connect(
    mapStateToProps,
    {
      updateSignupGenerator,
      clearUpdateSignupGeneratorStatus,
    },
  )(onClickOutside(EmailSignupFieldDecorator));
};

export default fieldDecorator;
